import {TrackingModalComponent} from './../../shared/tracking-modal/tracking-modal.component';
import {DashboardTrackingModalComponent} from './../../shared/dashboard-tracking-modal/dashboard-tracking-modal.component';
import {StockService} from './../services/stocks.service';
import {DashboardService} from './../services/dashboard.service';
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PaginationInstance} from 'ngx-pagination';
import {CommonAlertService} from "../../services/common-alert.service";

@Component({
  selector: 'app-used-implants',
  templateUrl: './missing-implants.component.html',
  styleUrls: ['./missing-implants.component.scss']
})
export class MissingImplantsComponent implements OnInit {

  public tracking: any;
  public filter: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By Product Name';

  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  constructor(public stockservice: StockService, public dashboardService: DashboardService, public dialog: MatDialog, public commonAlertService: CommonAlertService) {
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['missing_implants.view'] == 1) {
        this.viewPermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token'),
      tracking_type: 3 
     }
    this.getTrackingData();
  }

  getTrackingData() {
    this.stockservice.getTracking(this.filter).subscribe(res => {
      // @ts-ignore
      this.tracking = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;

      const newData = {
        product_name: '',
        location_name: '',
        warehouse_name: '',
        store_name: '',
        current_status: '',
        date_displacement: ''
      };


      if (this.tracking.length < this.per_page) {
        for (let i = 0; i < this.itemToBePushed; i++) {
          this.tracking.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });

  }

  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By Product Name';
          break;
        case '1':
          this.placeHolder = 'Search By City Name';
          break;
        case '3':
          this.placeHolder = 'Search by Store Name';
          break;
        default:
          this.placeHolder = 'Search By Product Name';
      }
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(TrackingModalComponent, {
      minWidth: '40vw',
      minHeight: '20vh',
      disableClose: true
    }).afterClosed().subscribe(() => this.getTrackingData());
  }

  editDialog(i): void {
    const editId = this.tracking[i].id;
    const encID = this.tracking[i].enc_id;
    // tslint:disable-next-line:triple-equals
    if (editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(TrackingModalComponent, {
        minWidth: '40vw',
        minHeight: '20vh',
        disableClose: true,
        data: {
          edit: {
            editID: editId,
            encryId: encID
          }
        }
      }).afterClosed().subscribe(() => this.getTrackingData());
    }
  }


  openTrackingModal(stockId): any {
    if (stockId) {
    this.dashboardService.getDisplacementDetails(stockId).subscribe(res => {
      const dialogRef = this.dialog.open(DashboardTrackingModalComponent, {
        minWidth: '50vw',
        minHeight: '50vh',
        disableClose: true,
        data: res
      });
    });
  }
}

  doSearch(): void {
    if (this.searchBy != null) {
      switch (this.searchBy) {
        case '0':
          Object.assign(this.filter, {search: {type: 'int', field: 'products.name', text: this.searchTxt}});
          break;
        case '1':
          Object.assign(this.filter, {search: {type: 'int', field: 'locations.name', text: this.searchTxt}});
          break;
        case '3':
          Object.assign(this.filter, {search: {type: 'int', field: 'stores.name', text: this.searchTxt}});
          break;
        default:
          Object.assign(this.filter, {search: {type: 'int', field: 'products.name', text: this.searchTxt}});
      }
    }
    /*this.filter = {'search':{'type': this.searchBy.type, 'field': this.searchBy.field, 'text': this.searchTxt}};*/
    this.getTrackingData();
  }

  doRefresh(): void {
    this.searchTxt = null;
    this.filter = {
      token: localStorage.getItem('token'),
      tracking_type: 2 
    };
    this.getTrackingData();
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getTrackingData();
  }
}
